import { t } from "i18next";
import { CorePropsInterfaces, DTOs } from "src/core/Models";
import GtDialog from "./GtDialog";
import { Button, TextField } from "@mui/material";
import { useState } from "react";

function GtChangeEmailDialog({
  engagementLetterSignee,
  onEmailChanged,
  onDialogClose,
}: CorePropsInterfaces.GtChangeEmailDialogProps): JSX.Element {
  const [email, setEmail] = useState(engagementLetterSignee.Email);
  const changeEmailDialogDTO: DTOs.GtDialogDTO = {
    data: {
      title: t("General.ChangeEmailFor", {
        Name:
          (engagementLetterSignee.FirstName || "") +
          " " +
          (engagementLetterSignee.LastName || ""),
      }),
      maxWidth: "md",
      leftButtons: [],
      rightButtons: [
        <Button
          onClick={onDialogClose}
          color="tertiary"
          variant="outlined"
          key="cancelBtn"
        >
          {t("General.Cancel")}
        </Button>,
        <Button
          color="tertiary"
          variant="contained"
          key="confirmBtn"
          onClick={() => {
            onEmailChanged(email);
          }}
        >
          {t("General.SaveAndUpdate")}
        </Button>,
      ],
    },
    api: {
      onClose: onDialogClose,
    },
    state: {
      isOpen: true,
      isFullWidth: true,
    },
  };

  return (
    <GtDialog gtDialogDTO={changeEmailDialogDTO}>
      <article className="gt-changeFieldDialog">
        <section className="gt-changeFieldDialog__currentSection">
          <span>{t("General.CurrentEmail")}</span>
          <TextField
            variant="outlined"
            value={`${engagementLetterSignee?.Email || ""}`}
            disabled={true}
          />
        </section>
        <section className="gt-changeFieldDialog__newSection">
          <span>{t("General.NewEmail")}</span>
          <TextField
            variant="outlined"
            value={`${email || ""}`}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </section>
      </article>
    </GtDialog>
  );
}

export default GtChangeEmailDialog;
